var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRuble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15695_19288)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9219 11.2724H5.01282V10.0224H10.9219C11.4674 10.0224 11.9181 9.92768 12.2742 9.73828C12.6302 9.5451 12.8954 9.28374 13.0696 8.95419C13.2439 8.62086 13.331 8.24207 13.331 7.81783C13.331 7.39358 13.2439 7.01669 13.0696 6.68715C12.8954 6.35381 12.6302 6.09245 12.2742 5.90305C11.9181 5.70987 11.4674 5.61328 10.9219 5.61328H8.26282V15.9996H6.85373V4.36328H10.9219C11.7855 4.36328 12.4977 4.52048 13.0583 4.83487C13.6189 5.14927 14.0355 5.56783 14.3083 6.09055C14.581 6.61328 14.7174 7.18904 14.7174 7.81783C14.7174 8.44661 14.581 9.02237 14.3083 9.5451C14.0355 10.0678 13.6189 10.4864 13.0583 10.8008C12.4977 11.1152 11.7855 11.2724 10.9219 11.2724ZM10.831 12.3633V13.6133H5.01282V12.3633H10.831Z",
    fill: "#ADBFDF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15695_19288"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRuble);
export default __webpack_public_path__ + "static/media/iconRuble.a6d1f0e36a3677e1f16b6a2d3b6b409e.svg";
export { ForwardRef as ReactComponent };